import React, { PureComponent } from 'react';

/**
 * Components.
 */
import LandingSection from 'components/landing-section';
import LandingForm from 'modules/landing/forms';

/**
 * Icons.
 */
import AfiliationIcon from 'assets/icons/afiliation-white.svg';

/**
 * Images.
 */
// import PortugalImage from 'assets/images/portugal.png';

/**
 * Style.
 */
import './fifth-section.scss';

class FifthSection extends PureComponent {
  render() {
    const { reference, onSubmitForm } = this.props;

    return (
      <LandingSection className="fifth-section" reference={reference}>
        <div className="mask" />
        <div className="fifth-section-content-wrapper">
          <div className="fifth-section-content-header">
            Inicie Sua Afiliação
          </div>
          <hr />
          <div className="fifth-section-content-sub-header">
            Através do nosso sistema de ensino, você será capaz de utilizar as
            potencialidades que lhe são naturais para realizar aquilo
            que mais deseja que aconteça em sua vida.
            <br />
            Seja bem-vindo a uma viagem ao âmago do seu ser!
          </div>
          <div className="fifth-section-content">
            <div className="fifth-section-content-title">
              <img src={AfiliationIcon} alt="" />
              Iniciar Processo De Afiliação:
            </div>
            <div className="fifth-section-content-form">
              {/* <div className="fifth-section-portugal">
                <img src={PortugalImage} alt="Portugal" className="imagem" />
                <div className="texto-container">
                  <div className="fifth-section-portugal-title">ATENÇÃO!</div>
                  <div className="fifth-section-portugal-content ">
                    Se você é residente em
                    {' '}
                    <b>Portugal</b>
                    , para afiliar-se conosco
                    {' '}
                    <a href="https://amorc.org.br">clique aqui</a>
                  </div>
                </div>
              </div> */}
              <LandingForm onSubmit={onSubmitForm} />
            </div>
          </div>
        </div>
      </LandingSection>
    );
  }
}

export default FifthSection;
